import React, { Dispatch, SetStateAction, useRef } from 'react'

import { Button, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'

import AgreedTermsCheckbox from 'components/AgreedTermsCheckbox/AgreedTermsCheckbox'
import { RichTextField } from 'components/Form'
import IdeaFlameMotivator, {
	useRichTextToIdeas,
} from 'components/IdeaFlameMotivator/IdeaFlameMotivator'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'

import { styles } from './Section3.styles'

export const TEST_ID = 'building-blocks-section3'

export type Props = {
	authorIdeation: string
	cautionText?: string
	gameId?: string
	loading: boolean
	setAuthorIdeation: (val: string) => void
	setTermsAgreed: Dispatch<SetStateAction<boolean>>
	submitIdeas: () => void
	submitIdeasDisabled: () => boolean
	termsAgreed: boolean
	viewSubmittedIdeas: () => void
}

const Section3 = (props: Props) => {
	const richTextFieldRef = useRef(null)
	const richTextToIdeas = useRichTextToIdeas()

	return (
		<>
			<Typography sx={styles.ideationTypography}>IDEATION</Typography>
			<Box sx={styles.mainBox}>
				<Box sx={styles.sideBar} />
				<Box sx={styles.typographyBox}>
					<Typography
						sx={styles.richTextFieldDescription}
						data-testid={`${TEST_ID}__first_typography`}
					>
						Document any ideas inspired by the facilitation
						technique to address your innovation topic.
					</Typography>
					<Grid
						item
						sx={styles.richTextFieldGrid}
						data-testid={`${TEST_ID}__ideation`}
					>
						<RichTextField
							ref={richTextFieldRef}
							onChange={props.setAuthorIdeation}
							value={props.authorIdeation}
							placeholderText="Brainstorm your ideas here!"
							sx={styles.richTextField}
							iconColor="#45657B"
						/>
					</Grid>
					<Box>
						<IdeaFlameMotivator
							ideaCount={richTextToIdeas(props.authorIdeation)}
							variant="BUILDING_BLOCKS"
						/>
					</Box>
					<AgreedTermsCheckbox
						setTermsAgreed={props.setTermsAgreed}
						termsAgreed={props.termsAgreed}
						gameId={props.gameId}
					/>
					<Box sx={styles.submitButtonBox}>
						<Button
							color="secondary"
							variant="contained"
							data-testid={`${TEST_ID}__submit-idea-button`}
							onClick={props.submitIdeas}
							disabled={
								props.submitIdeasDisabled() || props.loading
							}
						>
							{props.loading ? (
								<LoadingSpinner inline />
							) : (
								<Typography>SUBMIT IDEAS</Typography>
							)}
						</Button>
						<Button
							disabled={props.loading}
							variant="text"
							color="secondary"
							data-testid={`${TEST_ID}__view-submit-ideas-button`}
							onClick={props.viewSubmittedIdeas}
						>
							{props.loading ? (
								<LoadingSpinner inline />
							) : (
								<Typography>
									VIEW ALL SUBMITTED IDEAS
								</Typography>
							)}
						</Button>
					</Box>
					<Typography sx={styles.cautionTypography}>
						{props.cautionText}
					</Typography>
				</Box>
			</Box>
		</>
	)
}
export default Section3
